import { REDUX_STORE } from '@funnels/constants';
import { LeadActionTypes, LeadReducerState, SharedActionTypes } from '@funnels/types';

const initialState: LeadReducerState = {
  data: null,
  error: null,
  loading: 0,
};

export default function leadReducer(
  state: LeadReducerState = initialState,
  action: LeadActionTypes | SharedActionTypes
): LeadReducerState {
  switch (action.type) {
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_DATA:
      return {
        ...state,
        data: null,
      };
    case REDUX_STORE.SHARED_ACTION_TYPES.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case REDUX_STORE.LEAD.ACTION_TYPES.FETCH_LEAD:
      return {
        ...state,
        data: null,
        loading: 1,
      };
    case REDUX_STORE.LEAD.ACTION_TYPES.FETCH_LEAD_SUCCESS:
      return {
        ...state,
        data: action.lead,
        loading: 0,
      };
    case REDUX_STORE.LEAD.ACTION_TYPES.FETCH_LEAD_FAIL:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}
